/* Instagram reels band: a tile opens its reel in a dialog with Instagram's own
   player (the embed iframe) instead of leaving the site. Without this script the
   tiles are ordinary links to Instagram. The iframe is created on open and
   removed on close, so no Instagram code loads until someone asks for a reel. */
(function () {
  document.querySelectorAll('[data-reels]').forEach(function (band) {
    var dialog = band.querySelector('[data-reel-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var frame = dialog.querySelector('[data-reel-frame]');
    var openLink = dialog.querySelector('[data-reel-open]');
    var lastTile = null;

    function close() {
      if (dialog.open) dialog.close();
    }
    dialog.addEventListener('close', function () {
      frame.innerHTML = '';
      if (lastTile) lastTile.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-reel-close]').addEventListener('click', close);
    // a click on the backdrop (the dialog box itself, outside its content) closes it
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    band.querySelectorAll('[data-reel-embed]').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        lastTile = tile;
        var title = (tile.querySelector('.reel-title') || {}).textContent || 'Instagram reel';
        frame.innerHTML = '';
        var f = document.createElement('iframe');
        f.src = tile.getAttribute('data-reel-embed');
        f.title = title;
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('scrolling', 'yes');
        frame.appendChild(f);
        openLink.href = tile.href;
        dialog.showModal();
        dialog.querySelector('[data-reel-close]').focus();
      });
    });
  });
})();
